import { contactNumbersSchema, readPhone } from '@hue/contracts';
import type { CompanyContactDetails } from '../lib/api.js';

export const EMPTY_COMPANY_CONTACTS: CompanyContactDetails = {
  contactNumbers: [],
  email: null,
  taxId: null,
  address: null,
};
export function contactNumbersError(
  value: CompanyContactDetails['contactNumbers'],
): string | undefined {
  const parsed = contactNumbersSchema.safeParse(value);
  return parsed.success ? undefined : parsed.error.issues[0]?.message;
}
export function copiedContactNumbers(
  current: CompanyContactDetails['contactNumbers'],
  source: CompanyContactDetails['contactNumbers'],
) {
  const sources = new Map(source.map((contact) => [contact.number, contact]));
  const next = current.map((contact) => {
    const number = readPhone(contact.number)?.e164 ?? contact.number;
    const own = sources.get(number);
    sources.delete(number);
    const channels = [...new Set([...contact.channels, ...(own?.channels ?? [])])];
    return {
      ...contact,
      channels,
      isPublic: channels.length > contact.channels.length ? false : contact.isPublic,
    };
  });
  return [
    ...next,
    ...[...sources.values()].map((contact) => ({
      ...contact,
      channels: [...contact.channels],
      isPublic: false,
    })),
  ];
}
